import "./style.scss"; // Import custom styles
import "../../../assets/css/CountryCode.scss"; // Import country code styles

import {
  Container, CssBaseline, Grid, Paper,
} from "@material-ui/core"; // Material-UI components

import PropTypes from "prop-types"; // PropTypes for type checking

import { connect } from "react-redux"; // Redux connect for state management

import React from "react"; // React library
import AppLoader from "components/AppLoader/Index"; // Custom loader component
import isEmpty from "lodash/isEmpty"; // Lodash utility for checking empty objects
import decodeJwt from "../../../Utils/decodeJwt";

// ===== OPTION B: Removed Frontegg SDK auth hooks =====
// SDK is now ONLY used for OAuth identity provider, not auth lifecycle
// useAuth, useLoginWithRedirect, ContextHolder removed - App manages auth
import {
  loginRequestFrontegg,
  setUserRole,
  setAppBarName,
  setLayoutName,
  getUserLeftMenuCall,
  clientThemeCall,
  clientPortalConfig,
} from "../../../Redux/Actions/LoginActions"; // Redux actions for login
import {
  getUserDetailsById,
  getUserProfileImage,
} from "../../../Redux/Actions/UserRegistration"; // Redux actions for user registration
import { getOtpAction, getCountryList } from "../../../actions/login.action"; // Redux actions for OTP and country list
import { checkLayoutName } from "../../../Uintls/gloables"; // Utility function for layout name
import { managerUpdateCall } from "../../../actions/Operations"; // Redux action for manager updates

import useStyles from "./Style"; // Custom styles
import { getEmailData1 } from "../../../Redux/Actions/merchantInformation"; // Redux action for email data
import { profileCodePermissionCheck } from "../../../Utils/commonUtils"; // Utility for profile code checks
import {
  clearAuthStorage,
  redirectToFronteggLogout,
} from "../../../authSession";

function Login(props) {
  const classes = useStyles(); // Initialize custom styles
  const [loading] = React.useState(false); // State for loading status
  const version = process.env.REACT_APP_BUILD_VERSION_NUMBER; // App version

  const [countryCode, setCountryCode] = React.useState([]); // State for country codes
  let image; // Variable for logo image
  if (props.app.defaultTheme.status === true) {
    image = props.app.defaultTheme && props.app.defaultTheme.data[0].Logo_Image; // Set logo image if theme is available
  }
  const [errorText, setErrorText] = React.useState(); // State for error messages
  const [resendCountdown, setResendCountdown] = React.useState(10); // Countdown for resend actions
  const [apiCalled, setApiCalled] = React.useState(false); // State to track if API has been called
  const [isAPIUser, setIsAPIUser] = React.useState(false);
  const [isAPIUserMessage, setIsAPIUserMessage] = React.useState("");

  // Effect to handle login response and token decoding

  React.useEffect(() => {
    setIsAPIUser(props.app?.authError?.isAPIUser);
    setIsAPIUserMessage(props.app?.authError?.message);
  }, [props.app?.authError?.isAPIUser]);

  React.useEffect(() => {
    if (props.userData !== false) {
      if (props.userData && props.userData.status) {
        if (props.userData?.token) {
          localStorage.setItem(
            "token",
            `bearer ${props.userData.token}`
          );
        }
        const decoded = decodeJwt(props.userData.token);

        if (!decoded) {
          clearAuthStorage();
          setErrorText("Session data is invalid. Please login again.");
          return;
        }

        if (
          (decoded?.Platform_Accessibility === "API" ||
            decoded?.Platform_Accessibility === undefined) &&
          decoded?.Role_Permission_Data.Profile_Code !==
          profileCodePermissionCheck.profileCode.VCS
        ) {
          // Handle unauthorized access
          setErrorText(
            <div
              className="dashboardTiles"
              style={{ position: "relative" }}
            >
              <AppLoader loader={loading} />
              <Container component="main" className={classes.rootNew}>
                <CssBaseline />
                <Paper
                  elevation={3}
                  style={{
                    padding: "35px 35px",
                    background: "#fff",
                    width: "100%",
                    maxWidth: "760px",
                    height: "auto",
                    minHeight: "440px",
                    borderRadius: "12px",
                    overflow: "hidden",
                  }}
                >
                  <Grid container spacing={2} alignItems="center">
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      container
                      justifyContent="center"
                      alignItems="center"
                    >
                      <div
                        className={classes.brandLogo}
                        style={{
                          width: "100%",
                          height: "400px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          className="imgf"
                          style={{ maxWidth: "100%", height: "auto" }}
                          src={image}
                          alt="appName"
                        />
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={8}
                      style={{ borderLeft: "1px solid #EFEFF4" }}
                      InputProps={{
                        classes: {
                          root: classes.activeInputColor,
                          disabled: classes.disabledInput,
                        },
                      }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <h2>
                          You are not authorized to log in to the portal
                        </h2>
                      </div>
                    </Grid>
                  </Grid>
                </Paper>
              </Container>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "0 2rem",
                  position: "absolute",
                  bottom: "2rem",
                  color: "white",
                }}
              >
                <i>
                  Version:
                  {version}
                </i>
                <i
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "7px",
                  }}
                >
                  <div>Powered By:</div>
                  <img
                    style={{
                      width: "154px",
                    }}
                    className="imgf"
                    src="/images/tsc_logo.png"
                    alt="appName"
                  />
                </i>
              </div>
            </div>
          );
        } else {
          // Handle authorized access
          const idealPath = "";
          let LandingPage = "/";
          let MainCat = "";
          if (idealPath) {
            LandingPage = idealPath.landingPageName;
          } else {
            LandingPage = decoded.Role_Permission_Data.LandingPage;
            MainCat =
              decoded.Role_Permission_Data.Main_Category_LandingPage;
          }
          props.setAppBarName(
            MainCat ? `${MainCat} / ${LandingPage}` : LandingPage
          );
          const layoutName = checkLayoutName(
            decoded.Role_Permission_Data.Profile_Code
          );
          props.setLayoutName(layoutName);
          if (idealPath) {
            props.history.push(idealPath.path);
          } else {
            props.history.push(
              `/${layoutName}/${LandingPage.replace(/\s/g, "")}`
            );
          }
          localStorage.setItem("menu", JSON.stringify(decoded));
          localStorage.setItem("clientId", decoded.ClientID);
          localStorage.setItem("userId", decoded.UserID);
          localStorage.setItem("profileId", decoded.Profile_Id);
          localStorage.setItem(
            "userProfileImage",
            decoded.userProfileImage
          );
          localStorage.setItem(
            "sendApiClientId",
            JSON.stringify([decoded.ClientID])
          );
          if (!apiCalled) {
            props.getUserDetailsById(decoded.UserID);
            setApiCalled(true);
          }
          props.setUserRole(decoded);
          props.getUserLeftMenuCall();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.userData]);

  React.useEffect(() => {
    let timer;
    if (resendCountdown > 0) {
      timer = setTimeout(() => setResendCountdown(resendCountdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [resendCountdown]);
  React.useEffect(() => {
    if (props.userData == false || props.userData.status == false) {
      setErrorText(
        <div className="dashboardTiles" style={{ position: "relative" }}>
          <AppLoader loader={loading} />
          <Container component="main" className={classes.rootNew}>
            <CssBaseline />
            <Paper
              elevation={3}
              style={{
                padding: "35px 35px",
                background: "#fff",
                width: "100%",
                maxWidth: "760px",
                height: "auto",
                minHeight: "440px",
                borderRadius: "12px",
                overflow: "hidden",
              }}
            >
              <Grid container spacing={2} alignItems="center">
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  container
                  justifyContent="center"
                  alignItems="center"
                >
                  <div
                    className={classes.brandLogo}
                    style={{
                      width: "100%",
                      height: "400px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      className="imgf"
                      style={{ maxWidth: "100%", height: "auto" }}
                      src={image}
                      alt="appName"
                    />
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={8}
                  style={{ borderLeft: "1px solid #EFEFF4" }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      disabled: classes.disabledInput,
                    },
                  }}
                >{isAPIUser ?
                  <div style={{ textAlign: "center" }}>
                    <h3> {isAPIUserMessage}</h3>
                    Redirecting to login page in&nbsp;&nbsp;
                    <span style={{ fontWeight: 800, fontSize: "15px" }}>{resendCountdown}</span>

                  </div> : <div style={{ textAlign: "center" }}>
                    <h2> {isAPIUserMessage ? isAPIUserMessage : "You are not authorized to log in to the portal"}</h2>
                    <h4>
                      {" "}
                      Redirecting to login page in&nbsp;&nbsp;
                      <span style={{ fontWeight: 800, fontSize: "15px" }}>{resendCountdown}</span>
                    </h4>
                  </div>}
                </Grid>
              </Grid>
            </Paper>
          </Container>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 2rem",
              position: "absolute",
              bottom: "2rem",
              color: "white",
            }}
          >
            <i>
              Version:
              {version}
            </i>
            <i
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "7px",
              }}
            >
              <div>Powered By:</div>

              <img
                style={{
                  width: "154px",
                }}
                className="imgf"
                src="/images/tsc_logo.png"
                alt="appName"
              />
            </i>
          </div>
        </div>
      );
      if (resendCountdown === 0) {
        clearAuthStorage();
        redirectToFronteggLogout();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, resendCountdown]);

  React.useEffect(() => {
    if (isEmpty(countryCode) && !props.app.defaultTheme === false) {
      props.getCountryList((data) => {
        setCountryCode(data.Country_Data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{errorText}</>;
}

// Define prop types for the component
Login.propTypes = {
  history: PropTypes.object, // React Router history object for navigation
  loginRequestFrontegg: PropTypes.func, // Redux action for Frontegg login
  userData: PropTypes.object, // User data from Redux state
  setUserRole: PropTypes.func, // Redux action to set user role
  setAppBarName: PropTypes.func, // Redux action to set app bar name
  setLayoutName: PropTypes.func, // Redux action to set layout name
  getCountryList: PropTypes.func, // Redux action to fetch country list
  app: PropTypes.object, // App state from Redux
};

// Map Redux state to component props
const mapStateToProps = ({ app }) => ({
  userData: app.userDetails, // Map user details from Redux state
  app,
  formData: app,
});

// Connect component to Redux and export
export default connect(mapStateToProps, {
  loginRequestFrontegg,
  setUserRole,
  setAppBarName,
  clientPortalConfig,
  setLayoutName,
  getOtpAction,
  getCountryList,
  clientThemeCall,
  getUserDetailsById,
  getUserProfileImage,
  getUserLeftMenuCall,
  managerUpdateCall,
  getEmailData1,
})(Login);
